import dayjs, { Dayjs } from 'dayjs';
import { Ummeldung } from '../../../../generated/model/ummeldung.model';
import { CustomValidators } from '@shared-ikp/utils/validators';
import { AbstractControl } from '@angular/forms';
import { mapDateStringToDayjs, mapDateStringToNgbDateStruct, mapNgbDateStructToDateString } from '@shared-ikp/utils/date.utils';
import { DATE_FORMAT_BACKEND } from '@shared-ikp/app.constants';
import { DatumFormValue } from '../schemas';

export function mapUmmeldungToDatumFormValue(ummeldung: Ummeldung | null): DatumFormValue {
  const isSmartMeter = ummeldung?.produktdaten?.at(0)?.isSmartMeter === true;
  return { ummeldedatum: isSmartMeter ? mapDateStringToNgbDateStruct(ummeldung?.ummeldedatum, DATE_FORMAT_BACKEND) : null };
}

export function resolveUmmeldedatumForStore(draft: DatumFormValue, ummeldung: Ummeldung | null): string | null {
  const produktdaten = ummeldung?.produktdaten?.at(0);

  if (produktdaten?.isSmartMeter === true) {
    const value = draft.ummeldedatum;
    const isValid = value && CustomValidators.ummeldedatumValidator({ value } as AbstractControl) === null;
    return isValid ? mapNgbDateStructToDateString(value, DATE_FORMAT_BACKEND) : null;
  }

  if (produktdaten?.isSmartMeter === false) {
    return resolvedManualUmmeldedatum(ummeldung)?.format(DATE_FORMAT_BACKEND) ?? null;
  }

  return null;
}

export function resolvedManualUmmeldedatum(ummeldung: Ummeldung | null): Dayjs | null {
  const produktdaten = ummeldung?.produktdaten?.at(0);
  const hasManualMeterReading =
    produktdaten?.isSmartMeter === false && !produktdaten?.hasNoZaehlerstand && produktdaten?.zaehlerstand != null;

  if (!hasManualMeterReading) {
    return null;
  }

  return parseStoredUmmeldedatum(ummeldung) ?? dayjs();
}

export function parseStoredUmmeldedatum(ummeldung: Ummeldung | null): Dayjs | null {
  const ummeldedatum = ummeldung?.ummeldedatum;
  return mapDateStringToDayjs(ummeldedatum, DATE_FORMAT_BACKEND);
}
